import { ManageUsersSection } from 'modules';



export const UsersActivity = () => {
  return (
    <ManageUsersSection.FC />
  );
};
